// Broadway shows + tours — resolves elements that reference a
// broadway.org show OR tour by ID against the corresponding live feed.
//
// Markup contract:
//   <img data-broadway-show-id="766" alt="">               → sets img.src   (from shows feed)
//   <div data-broadway-show-id="766"></div>                → sets background-image
//   <a   data-broadway-show-link-id="766">Title</a>        → sets a.href    (from show.showLink)
//   <img data-broadway-tour-id="123" alt="">               → sets img.src   (from tours feed)
//   <a   data-broadway-tour-link-id="123">Title</a>        → sets a.href    (from tour.showLink)
//
// One fetch per feed per page load; subsequent loads browser-cached.

const SHOWS_FEED = 'https://www.broadway.org/feeds/all-shows.php'
const TOURS_FEED = 'https://www.broadway.org/feeds/all-tours.php'

// Feed URLs come HTML-entity-encoded — decode before use.
const decodeUrl = (url) => (url || '').replace(/&amp;/g, '&')

function resolveImg(el, byId, idAttr) {
    const id = el.dataset[idAttr]
    if (!id) return
    const show = byId.get(String(id))
    // No matching entry OR no image → blank, not broken icon.
    if (!show || !show.image) {
        if (el.tagName === 'IMG') el.remove()
        else el.style.display = 'none'
        return
    }
    const url = decodeUrl(show.image)
    if (el.tagName === 'IMG') {
        el.src = url
        if (!el.alt) el.alt = show.title || ''
    } else {
        el.style.backgroundImage = `url("${url}")`
    }
}

function resolveLink(el, byId, idAttr) {
    const id = el.dataset[idAttr]
    if (!id) return
    const show = byId.get(String(id))
    const link = show
        ? decodeUrl(show.showLink || show.link || show.url || '')
        : ''
    if (link) {
        el.setAttribute('href', link)
        return
    }
    // No link → unwrap the anchor into a plain span keeping inner text.
    const span = document.createElement('span')
    if (el.className) span.className = el.className
    while (el.firstChild) span.appendChild(el.firstChild)
    el.replaceWith(span)
}

function fetchFeed(url) {
    return fetch(url, { credentials: 'omit' })
        .then((r) => {
            if (!r.ok) throw new Error('Feed HTTP ' + r.status)
            return r.json()
        })
        .then((data) => new Map(
            (Array.isArray(data) ? data : []).map((s) => [String(s.id), s])
        ))
        .catch((err) => {
            console.error('Broadway feed error:', url, err)
            return new Map()
        })
}

const broadwayShows = {
    init() {
        const showImgs  = document.querySelectorAll('[data-broadway-show-id]')
        const showLinks = document.querySelectorAll('[data-broadway-show-link-id]')
        const tourImgs  = document.querySelectorAll('[data-broadway-tour-id]')
        const tourLinks = document.querySelectorAll('[data-broadway-tour-link-id]')

        const needShows = showImgs.length || showLinks.length
        const needTours = tourImgs.length || tourLinks.length
        if (!needShows && !needTours) return

        if (needShows) {
            fetchFeed(SHOWS_FEED).then((byId) => {
                showImgs.forEach((el) => resolveImg(el, byId, 'broadwayShowId'))
                showLinks.forEach((el) => resolveLink(el, byId, 'broadwayShowLinkId'))
            })
        }
        if (needTours) {
            fetchFeed(TOURS_FEED).then((byId) => {
                tourImgs.forEach((el) => resolveImg(el, byId, 'broadwayTourId'))
                tourLinks.forEach((el) => resolveLink(el, byId, 'broadwayTourLinkId'))
            })
        }
    },
}

export default broadwayShows
